import { Package, UtensilsCrossed, Fuel, Wrench, Receipt } from "lucide-react";

export const SPESA_CAT = {
  materiali: { label: "Materiali", icon: Package, tone: "bg-sky-100 text-sky-700 dark:bg-sky-950/50 dark:text-sky-300" },
  pranzi: { label: "Pranzi", icon: UtensilsCrossed, tone: "bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300" },
  carburante: { label: "Carburante", icon: Fuel, tone: "bg-rose-100 text-rose-700 dark:bg-rose-950/50 dark:text-rose-300" },
  noleggio: { label: "Noleggio attrezzi", icon: Wrench, tone: "bg-violet-100 text-violet-700 dark:bg-violet-950/50 dark:text-violet-300" },
  altro: { label: "Altro", icon: Receipt, tone: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
};

export default SPESA_CAT;
